module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"F1F6HVYURM","searchOnlyApiKey":"6707a3e190b4b51c9786669fff61f338","indexName":"CONTENT"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/search.json
// module id = 804
// module chunks = 254572558124955